import React from 'react';
import { PencilIcon, EyeIcon, CopyIcon, TrashIcon, PhoneIcon, MapPinIcon, CalendarCheckIcon } from '../common/Icons';
import { StatusChip, PaymentChip, displayPhone, getInitials } from './CustomerBadges';

const CustomerCard = ({
  customer,
  onEdit,
  onCopy,
  onDelete,
  isLoading,
  formatDate,
  remainingAmount,
  showPayment = true, // Montajcı fiyat/ödeme bilgisi görmez
  permissions = {} // Rol bazlı yetkiler
}) => {
  const canEdit = permissions?.canEditCustomer;
  return (
    <article className="cl-card">
      <div className="cl-card-top">
        <span className="cl-avatar" aria-hidden="true">{getInitials(customer.name)}</span>
        <button type="button" className="cl-card-name" onClick={() => onEdit(customer)} disabled={isLoading}>
          <strong>{customer.name || 'İsimsiz müşteri'}</strong>
          {customer.tcNo && <span>TC/VKN {customer.tcNo}</span>}
        </button>
        <StatusChip status={customer.orderStatus} />
      </div>

      <dl className="cl-card-meta">
        {customer.phone1 && (
          <div>
            <dt><PhoneIcon size={14} /><span className="cl-sr">Telefon</span></dt>
            <dd><a href={`tel:+${customer.phone1.replace(/\D/g, '')}`}>{displayPhone(customer.phone1)}</a></dd>
          </div>
        )}
        <div>
          <dt><CalendarCheckIcon size={14} /><span className="cl-sr">Tarihler</span></dt>
          <dd>
            Sipariş {formatDate(customer.orderDate)} · Teslim {formatDate(customer.deliveryDate)}
            {customer.deliveryTime ? ` ${customer.deliveryTime}` : ''}
          </dd>
        </div>
        {customer.address && (
          <div>
            <dt><MapPinIcon size={14} /><span className="cl-sr">Adres</span></dt>
            <dd className="cl-card-address">{customer.address}</dd>
          </div>
        )}
      </dl>

      {customer.notes && <p className="cl-card-note">{customer.notes}</p>}

      <div className={`cl-card-foot${showPayment ? '' : ' is-actions-only'}`}>
        {showPayment && (
          <div className="cl-card-pay">
            <span>Kalan ödeme</span>
            <PaymentChip amount={remainingAmount} completed={customer.isPaymentCompleted} />
          </div>
        )}
        <div className="cl-actions">
          <button
            type="button"
            className="cl-icon-btn"
            onClick={() => onEdit(customer)}
            disabled={isLoading}
            aria-label={canEdit ? `${customer.name} düzenle` : `${customer.name} detaylar`}
            title={canEdit ? 'Düzenle' : 'Detaylar'}
          >
            {canEdit ? <PencilIcon size={16} /> : <EyeIcon size={16} />}
          </button>
          {permissions?.canCreateCustomer && (
            <button
              type="button"
              className="cl-icon-btn"
              onClick={() => onCopy(customer)}
              disabled={isLoading}
              aria-label={`${customer.name} kopyala`}
              title="Müşteriyi kopyala"
            >
              <CopyIcon size={16} />
            </button>
          )}
          {permissions?.canDeleteCustomer && (
            <button
              type="button"
              className="cl-icon-btn cl-icon-danger"
              onClick={() => onDelete(customer)}
              disabled={isLoading}
              aria-label={`${customer.name} sil`}
              title="Sil"
            >
              <TrashIcon size={16} />
            </button>
          )}
        </div>
      </div>
    </article>
  );
};

export default CustomerCard;
